import { TRANSACTION_FITLER } from "../../../types/types";

/**
 * Sets the start date for the filter.
 * 
 * @param days amount of days to subtract from the current date.
 * @returns 
 */
export const setDateFilter = () => {
  let date = new Date();
  date.setDate(date.getDate() - TRANSACTION_FITLER.dateToSet);
  return date;
}

/**
 * Helper function to set the max and min date for the date input fields.
 * 
 * @param days 
 * @returns 
 */
export const setMaxMinDate = (days: number) => {
  return new Date(new Date().setDate(new Date().getDate() - days)).toISOString().split('T')[0];
}

/**
 * Prepares the model data for the transaction api.
 * 
 * @param startDate 
 * @param endDate 
 * @returns 
 */
export const getModelData = (startDate: Date, endDate: Date) => {
  return {
    startDate: startDate.toISOString().slice(0, 19).replace('T', ' '),
    endDate: endDate.toISOString().slice(0, 19).replace('T', ' '),
    showErrors: 0
  }
}

/**
 * Get the date range and ensure it is within 31 days.
 * 
 * @param startDate 
 * @param endDate 
 * @returns 
 */
export const ensureDateRangeWithin31Days = (startDate: Date, endDate: Date): [Date, Date] => {
  const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
  const thirtyOneDaysInMilliseconds = 31 * oneDayInMilliseconds;

  const differenceInMilliseconds = Math.abs(endDate.getTime() - startDate.getTime());

  if (differenceInMilliseconds > thirtyOneDaysInMilliseconds) {
    // If the range is more than 31 days, adjust the end date to be 31 days after the start date
    const newEndDate = new Date(startDate.getTime() + thirtyOneDaysInMilliseconds);
    return [startDate, newEndDate];
  } else {
    // If the range is within 31 days, return the dates as they are
    return [startDate, endDate];
  }
}